<template>
    <form @submit.prevent="sendForm">
        <div class="container mb-4">
            <div class="k-panel k-panel--grid">
                <div class="k-panel__body k-panel__body--2-3 k-border-right">
                    <h3 class="k-h-tertiary k-mb-30">Základní údaje</h3>

                    <div class="k-form">
                        <div class="k-form__name-group">
                            <div class="k-form__name-group-item">
                                <label class="k-form__label">Titul před</label>
                                <input
                                        class="k-form__input"
                                        type="text"
                                        placeholder="Zadejte titul před"
                                        v-model="form.title_before"
                                >
                                <field-error v-if="form_errors.title_before">{{ form_errors.title_before[0] }}
                                </field-error>
                            </div>

                            <div class="k-form__name-group-item">
                                <label class="k-form__label">Jméno uživatele</label>
                                <input
                                        class="k-form__input"
                                        type="text"
                                        placeholder="Zadejte jméno uživatele"
                                        v-model="form.name"
                                >
                                <field-error v-if="form_errors.name">{{ form_errors.name[0] }}</field-error>
                            </div>

                            <div class="k-form__name-group-item">
                                <label class="k-form__label">Titul za</label>
                                <input
                                        class="k-form__input"
                                        type="text"
                                        placeholder="Zadejte titul za"
                                        v-model="form.title_after"
                                >
                                <field-error v-if="form_errors.title_after">{{ form_errors.title_after[0] }}
                                </field-error>
                            </div>
                        </div>

                        <div class="k-form__half-group">
                            <div>
                                <label class="k-form__label">Pobočka zaměstnance</label>
                                <select
                                        class="form-control k-choices--single"
                                        name="choices-single-no-search"
                                        v-model="form.branch_office_id"
                                >
                                    <option value placeholder>Vyberte pobočku</option>
                                    <option v-for="(item, index) in branchOffices" :value="index">{{ item }}</option>
                                </select>
                                <field-error v-if="form_errors.branch_office_id">{{ form_errors.branch_office_id[0] }}
                                </field-error>
                            </div>

                            <div>
                                <label class="k-form__label">Pracovní zařazení</label>
                                <select
                                        class="form-control k-choices--single"
                                        name="choices-single-no-search"
                                        v-model="form.job_title_id"
                                >
                                    <option value placeholder>Vyberte pracovní zařazení</option>
                                    <option v-for="(item, index) in jobTitles" :value="index">{{ item }}</option>
                                </select>
                                <field-error v-if="form_errors.job_title_id">{{ form_errors.job_title_id[0] }}
                                </field-error>
                            </div>
                        </div>
                    </div>

                    <h3 class="k-h-tertiary k-mt-50">Kontaktní údaje</h3>
                    <div class="k-form__half-group">
                        <div>
                            <label class="k-form__label">Telefonní číslo</label>
                            <input
                                    class="k-form__input"
                                    type="text"
                                    placeholder="Zadejte telefonní číslo"
                                    v-model="form.phone"
                            >
                            <field-error v-if="form_errors.phone">{{ form_errors.phone[0] }}</field-error>
                        </div>

                        <div>
                            <label class="k-form__label">E-mailová adresa</label>
                            <input
                                    class="k-form__input"
                                    type="text"
                                    placeholder="Zadejte e-mailovou adresu"
                                    v-model="form.email"
                            >
                            <field-error v-if="form_errors.email">{{ form_errors.email[0] }}</field-error>
                        </div>
                    </div>
                </div>

                <div class="k-panel__body k-panel__body--1-3  text-center">
                    <h3 class="k-h-tertiary k-mb-30">Profil</h3>

                    <label class="k-form__label">Fotografie</label>
                    <div class="k-user">
                        <div class="k-user__image">

                            <transition name="fade" mode="out-in">
                                <div v-if="showSpinner" key="spinner">
                                    <vue-simple-spinner
                                            class="mt-5"
                                            size="medium"
                                            message="Nahrávám fotografii..."
                                    />
                                </div>

                                <div v-else="!showSpinner" key="image">
                                    <img class="k-user__image-el"
                                         :src="image_src">

                                    <div v-if="form.image_name != null" @click="removeFile" title="Odstranit fotografii" class="k-user__image-remove">
                                        <svg role="img" width="20" height="20">
                                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use>
                                        </svg>
                                    </div>
                                </div>

                            </transition>

                        </div>

                        <input type="file" v-show="false" ref="image" accept=".png, .jpg, .jpeg" @change="handleFileUpload"/>

                        <div class="k-user__info">
                            <button @click.prevent="$refs.image.click()" class="k-btn k-btn--primary-outline">
                                Nahrát fotografii
                            </button>

                            <div class="k-help-text">
                                JPG nebo PNG, max. 5 MB
                            </div>
                            <field-error v-if="form_errors.image">{{ form_errors.image[0] }}</field-error>
                        </div>
                    </div>
                </div>

                <div class="k-panel__footer justify-content-between align-items-center">
                    <div class="k-panel__footer-btn">
                        <button class="k-btn k-btn--primary">Uložit</button>
                    </div>

                    <!--
                    <a
                        @click="deleteUser"
                        href="javascript:;"
                        class="k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex"
                    >
                        <svg class="" role="img" width="12" height="11">
                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use>
                        </svg>
                        Odstranit uživatele
                    </a>
                    -->
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import FormBase from '../FormBase.vue';
    import Spinner from 'vue-simple-spinner'

    export default {
        extends: FormBase,

        components: {
            'vue-simple-spinner': Spinner
        },

        props: {
            branchOffices: {
                type: Array,
                required: true
            },
            jobTitles: {
                type: Array,
                required: true
            },
            placeholderUrl: {
                type: String,
                required: true
            }
        },

        data: () => ({

            allowImageTypes: ['jpg', 'jpeg', 'png'],
            maximumSize: 5120000,   // max 5 MB
            showSpinner: false,

            form: {
                title_before: '',
                title_after: '',
                name: '',
                branch_office_id: '',
                job_title_id: '',
                phone: '',
                email: '',
                image_name: null,
                image_url: null,
            }
        }),

        computed: {
            image_src: function() {
                return this.form.image_url === null ? this.placeholderUrl : this.form.image_url;
            }
        },

        methods: {
            /**
             * Send user form
             *
             * @return void
             */
            sendForm: async function () {
                let result = await this.sendData();
                if (result !== undefined && result.message.length) {
                    flash(result.message, result.success ? 'success' : 'danger');
                }
            },

            /**
             * Delete user
             *
             * @return void
             */
            deleteUser: async function () {
                let result = await swal.fire({
                    title: 'Odstranit uživatele?',
                    text: "Uživatel bude nevratně odstraněn z databáze.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ano',
                    cancelButtonText: 'Ne'
                });

                if (result.value && result.value === true) {
                    //TODO Implement user remove functionality
                    alert('NE!!!!!!!!!!!!!!!!!!!!!');
                }
            },

            /**
             * Remove user image
             *
             * @return void
             */
            removeFile: function() {
                this.form.image_url = null;
                this.form.image_name = null;
            },

            /**
             * Upload image from user
             *
             * @param event
             * @return void
             */
            handleFileUpload: async function (event) {
                // reset error message
                this.cleanError('image');

                let file = event.target.files[0];
                if (file) {
                    if (this.validateImage(file)) {

                        // start ajax, show spinner
                        this.showSpinner = true;

                        let formData = new FormData();
                        formData.append('image', file);

                        try {
                            let result = await axios.post('/users/image-upload',
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                            );

                            if (result.status === 200 && result.data.success === true) {
                                this.form.image_url = result.data.image_url;
                                this.form.image_name = result.data.image_name;
                            }
                            else {
                                this.pushError('image', 'Nepovedlo se nahrát fotografii.');
                            }
                        }
                        catch(e) {
                            if (e.response.data.errors.image) {
                                this.form_errors.image = e.response.data.errors.image;
                            }
                            else {
                                console.log(e);
                                this.pushError('image', 'Nepovedlo se nahrát fotografii.');
                            }
                        }

                        // stop ajax, hide spinner
                        this.showSpinner = false;
                    }
                }
                else {
                    this.pushError('image', 'Nepovedlo se otevřít soubor.')
                }
            },

            /**
             * Validate image
             *
             * @return boolean
             */
            validateImage: function (image) {
                if (!this.allowImageTypes.includes(image.name.split(".").pop().toLowerCase())) {
                    this.pushError('image', 'Jsou povoleny pouze fotografie ve formátu JPG a PNG.');
                    return false;
                }

                if (image.size > this.maximumSize) {
                    this.pushError('image', 'Maximální velikost fotografie je 5 MB.');
                    return false;
                }

                return true;
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
